<nz-form-item class="input-field">
	<nz-form-control [formGroup]="this.form">
		<nz-form-label *ngIf="this.label">
			<div class="mb-3px color-text-default">{{ this.label }}</div>
		</nz-form-label>
		<nz-input-group
			[nzSuffix]="this.nzSuffix"
			[nzPrefix]="nzPrefix"
			[nzSize]="size"
		>
			<input
				[autocomplete]="
					this.inputType === 'password' ? 'new-password' : 'on'
				"
				class="color-grey"
				[type]="this.inputType"
				(ngModelChange)="handleOnChange($event)"
				nz-input
				formControlName="{{ this.formName }}"
				[placeholder]="this.placeholder"
			/>
		</nz-input-group>
		<span *ngIf="footNote?.length > 0" class="color-light-grey"
			>{{ footNote }}<br
		/></span>
		<app-validation-errors
			*ngIf="
				showValidationError &&
				(this.form?.controls[this.formName].touched ||
					this.form?.controls[this.formName].dirty)
			"
			[errors]="this.form?.get(this.formName).errors"
			label="{{ this.formName }}"
		>
		</app-validation-errors>
	</nz-form-control>
</nz-form-item>
